import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ThemeProvider } from "styled-components";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

import { AppDispatch, State } from "../../Redux/Store";

import { CreateContactUs } from "../../Redux/ContactUs/ContactUs.actions";

import ImgGT3 from "../../Assets/Img/ImgG&TContact.png";
import ImgGTMobile from "../../Assets/Img/ImgG&TMobile.png";

import { tContactUs } from "../../Models/ContactUs";

import { allowedPhoneNumber, allowedWord } from "../../Constants/Regexp";
import Modal from "../../Components/Modal";

import Layout from "../../Components/Layout";
import { Column, Container, Row } from "../../Components/Grid";
import StepsCard from "../../Components/StepsCard";
import Input from "../../Components/Input";
import Textarea from "../../Components/Textarea";
import PhoneNumberInput from "../../Components/PhoneNumberInput";
import { ButtonStyled } from "../../Components/Button/Button.styled";
import Icon from "../../Components/Icon";

import {
  ButtonSection,
  ContactButton,
  Form,
  ImgContact,
} from "./ContactUs.styled";

const ContactUs = () => {
  const theme = useSelector((state: State) => state.theme);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [, setToken] = useState("");
  const dispatch = useDispatch<AppDispatch>();
  const [showModalSuccess, setShowModalSuccess] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { isDirty, isValid, errors },
    control,
    reset,
  } = useForm({ mode: "onChange" });

  const onSubmit = useCallback(
    async (data: tContactUs) => {
      const formData = new FormData();
      formData.append("Fullname", data["FullName"] || "");
      formData.append("Email", data["Email"] || "");
      formData.append("PhoneNumber", `${data["PhoneNumber"]}` || "");
      formData.append("Comment", data["Comment"] || "");
      formData.append("Source", "Contact request from G&T");
      formData.append("Attachment", "");

      await dispatch(CreateContactUs(formData));
      hideModal();
      reset();
    },
    [executeRecaptcha]
  );

  useEffect(() => {
    if (!executeRecaptcha) {
      return;
    }
    const handleReCaptchaVerify = async () => {
      const token = await executeRecaptcha("contactUs");
      setToken(token);
    };
    handleReCaptchaVerify();
  }, [executeRecaptcha]);

  const hideModal = () => {
    setShowModalSuccess(!showModalSuccess);
  };

  return (
    <ThemeProvider theme={theme}>
      <Layout>
        <Container>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Column span={12}>
                <StepsCard image={ImgGT3} title="Contáctanos" />
                <ImgContact src={ImgGTMobile} />
              </Column>
            </Row>
            <Row>
              <Column span={12} as={Form}>
                <Input
                  textLabel="Ingresa tu nombre completo"
                  label="FullName"
                  register={register}
                  rules={{
                    required:
                      "Campo obligatorio.Por favor, completa antes de continuar",
                    pattern: {
                      value: allowedWord,
                      message: "Solo letras",
                    },
                  }}
                  errors={errors}
                />
                <Input
                  textLabel="Ingresa tu correo electrónico"
                  label="Email"
                  register={register}
                  rules={{
                    required:
                      "Campo obligatorio.Por favor, completa antes de continuar",
                    pattern: {
                      value: allowedWord,
                      message: "Solo letras",
                    },
                  }}
                  errors={errors}
                />
                <PhoneNumberInput
                  label="PhoneNumber"
                  labelText="Número de teléfono celular"
                  register={register}
                  errors={errors}
                  control={control}
                  rules={{
                    required:
                      "Campo obligatorio.Por favor, completa antes de continuar",
                    pattern: {
                      value: allowedPhoneNumber,
                      message: "Formato de teléfono inválido",
                    },
                  }}
                />
                <Textarea
                  label="Comment"
                  textLabel="Escríbenos tu consulta"
                  register={register}
                  rules={{
                    required:
                      "Campo obligatorio.Por favor, completa antes de continuar",
                  }}
                  errors={errors}
                />
              </Column>
            </Row>
            <Row>
              <Column span={12} as={ButtonSection}>
                <ContactButton
                  type="submit"
                  as={ButtonStyled}
                  color={!isDirty || !isValid ? "" : "Dark_Silver"}
                  disabled={!isDirty || !isValid}
                >
                  <span>Enviar</span>
                  <Icon icon="arrowRight" color="white" size="large" />
                </ContactButton>
              </Column>
            </Row>
          </form>
        </Container>
        <Modal
          show={showModalSuccess}
          handleOk={() => hideModal()}
          handleClose={() => hideModal()}
          IconHeader="circleCheck"
          TextButton="Listo"
          TextHeader="Tu información ha sido enviada"
          colorIcon="white"
        />
      </Layout>
    </ThemeProvider>
  );
};

export default withTranslation("ns")(ContactUs);
